import global from '@/core/global/global.js'
var param = global.global.getParam();
const params = {
  // 后期再协调
  evaId:param.idCard||"73",
  roleType:param.roleType||""
}
export default params;



// WEBPACK FOOTER //
// ./src/core/api/config/params.js